import store from './store';
import {
    required,
    validURL,
    email,
    min1,
    price,
    minProductPrice,
    minVal,
    minValRequired,
    maxShippingPrice,
    requiredNotEmptyString
} from "./validations";
import {serverValidation} from "./api/app";

export default {
    data(){
        return{
            validationRules:{
                required, requiredNotEmptyString, validURL, email, min1,price, minProductPrice, minVal,minValRequired,maxShippingPrice,
                max:(max) => {
                    return (val) => {
                        return val <= max || 'This field is invalid, max value is: '+max
                    }
                },
                validUnique: (data) => {
                    return serverValidation(data)
                },
                url:(str) => {
                    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                    return !!pattern.test(str) || 'This element should be valid URL address';
                },
            }
        }
    },
    computed:{
        dialogWidth(){
            return (this.$vuetify.breakpoint.mdAndUp)? '50%' : '95%'
        }
    },
    methods:{
        getStatus(status){
            var filtered =  store.getters.statuses.filter(item => {
                return item.key == status;
            })
            if(filtered.length > 0) return filtered[0];
            return {
                name: status,
                hex: '#f2f2f2'
            };
        },
        mobileCheck(){
            return this.$vuetify.breakpoint.smAndDown;
        },
        scrollToError(){
            const el = document.querySelector(".v-messages.error--text:first-of-type");
            if(el) el.scrollIntoView();
        }
    }
}
